<template>
    <section class="section">
        <h3 class="title is-3" :title="organizationFullPath(parent)">{{headerTextType}} {{$_get(parent, 'text')}}</h3>

        <a @click="$router.back()" v-if="parentId"><b-icon icon="backburger" size="is-small" /> Назад</a>

        <b-table
            :data="cpoList"

            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort-direction="asc"
            sort-icon="chevron-up"
            sort-icon-size="is-small"
            :selected.sync="selected"
            @click="openSelected"
            :loading="isLoading"
            paginated
            striped
            narrowed
            hoverable
            focusable

            default-sort="title"
            aria-next-label="Следующая страница"
            aria-previous-label="Предыдущая страница"
            aria-page-label="Страница"
            aria-current-label="Текущая страница"
        >

            <b-table-column cell-class="is-clickable" field="text" :label="typeTextColumn"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Поиск..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    <span :title="organizationFullPath( props.row)">{{ props.row.text }}</span>
                </template>
            </b-table-column>


            <b-table-column cell-class="is-clickable two" field="directorate" label="Общая информация" header-class="two">
                <template v-slot="props">

                </template>
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="directorate" label="АОС">
                <template v-slot="props">
                    {{ props.row.directorate }}
                </template>
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="directorate" label="ИТ">
                <template v-slot="props">
                    {{ props.row.directorate }}
                </template>
            </b-table-column>
        </b-table>
    </section>

</template>

<script>


import { mapActions, mapGetters } from 'vuex'
import { uniq, map, sortBy, get } from 'lodash'
import { TYPE_CPO, TYPE_DCS, TYPE_DIRECTION } from '../../../store/models/organizations/model'

export default {
    computed: {
        ...mapGetters({
            cpoQuery: 'e/organizations/query',
            isLoaderActive: 'e/pages/isLoaderActive',
        }),
        directorateList() {
            return sortBy(uniq(map(this.cpoList, 'directorate')))
        },
        dcsList() {
            return sortBy(uniq(map(this.cpoList, 'dcs')))
        },
        isLoading () {
            return this.isLoaderActive('cpo.fetchItems')
        },
        parentId() {
            return this.$route.params.id || null
        },
        parent() {
            return this.cpoQuery().with('children').find(this.parentId);
        },
        parentType() {
            return this.$_get(this.parent, 'type')
        },
        headerTextType () {
            switch (this.parentType) {
                case TYPE_DIRECTION:
                    return 'Дирекция'
                case TYPE_DCS:
                    return 'ДЦС'
                case TYPE_CPO:
                    return 'ЦПО'
                default:
                    return 'Дирекции'
            }
        },
        typeTextColumn() {
            switch (this.parentType) {
                case TYPE_DIRECTION:
                    return 'ДЦС'
                case TYPE_DCS:
                    return 'ЦПО'
                default:
                    return 'Дирекция'
            }
        },
        cpoList () {
            return this.parentId ? this.cpoQuery()
                .with('children')
                .where('parentId', this.parentId)
                .get() :
                this.cpoQuery()
                .with('children')
                .where('type', TYPE_DIRECTION)
                .get()
        }
    },
    mounted() {
        //this.fetch()
    },
    methods: {
        ...mapActions({
            fetch: 'e/organizations/fetchItems',
        }),
        organizationFullPath(item) {
            return item ? item.parentPath() : get(item, 'text')
        },
        openSelected(a) {
            this.$router.push({name: 'organizations.stats.show', params: {id: a.id}})
        }
    },
    data() {
        return {
            selected: null,
            currentPage: 1,
            perPage: 30
        }
    }
}
</script>